import { ReactComponent as Close } from "assets/icons/close.svg";

const PageHeader = ({ onClose }) => {
  return (
    <div
      className={`fixed h-auto top-0 px-5 w-full max-w-2xl mx-auto py-3 z-40 `}
    >
      <div className="flex justify-end">
        <Close
          className="w-6 h-6 [&>path]:stroke-white"
          onClick={() => onClose()}
        />
      </div>
    </div>
  );
};

export default PageHeader;
